import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import { Common } from 'wsm-common-data';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
/**
 * Filters undefined, null or empty strings from a list of comma separated items, joins them and returns a string
 * Returns null if 'classes' is empty
 * @param {object} classes - An arguments object
 */


var setClassNames = function setClassNames(classes) {
  var classList = new Set(classes);
  return _toConsumableArray(classList).filter(function (c) {
    return c;
  }).join(' ') || null;
};

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var validateNonZeroLengthString = function validateNonZeroLengthString(str, name) {
  if (typeof str !== 'string' || str.length === 0) {
    throw new Error("".concat(name, " must be a non-zero length string. Got: ").concat(str, "."));
  }
};
/**
 * Sets the event object for Google anlytics
 * @param {string} widgetName - A string value for widgetName
 * @param {string} widgetId - A string value for widgetId
 * @param {object} trackingObj - An object value for trackingObj
 */


var trackEvent = function trackEvent(widgetName, widgetId, trackingObj) {
  validateNonZeroLengthString(widgetName, 'Widget name');
  validateNonZeroLengthString(widgetId, 'Widget id');
  var isBrowser = typeof window !== 'undefined';

  if (isBrowser) {
    var _window = window,
        _window$DDC = _window.DDC,
        DDC = _window$DDC === void 0 ? {} : _window$DDC;
    var defaultTrackingObj = {
      action: 'clicked',
      element: undefined,
      elementCTA: undefined,
      event: 'widgetUserEvent',
      fieldValue: undefined,
      formEventId: undefined,
      formId: undefined,
      nonInteractive: false,
      result: undefined,
      sourceData: undefined,
      value: undefined,
      widgetId: widgetId,
      widgetName: widgetName,
      widgetState: 'default'
    };

    if (DDC.fireTrackingEvent) {
      DDC.fireTrackingEvent(_objectSpread2$1({}, defaultTrackingObj, {}, trackingObj));
    }

    return !!DDC.fireTrackingEvent;
  }

  return isBrowser;
};

/**
 * Adds a `#` to a valid hex color that is not already included
 * @param {string} color - A string value color
 */
var formatColor = function formatColor(color) {
  if (!color || color.length === 0) {
    return null;
  } else if (/(^[0-9A-F]{6}$)|(^[0-9A-F]{3}$)/i.test(color)) {
    return "#".concat(color);
  }

  return color;
};
/**
 * Adds darker border for buttons with custom backgroundColors
 * that are set to a hex value
 * @param {string} hex - A string value representing a hex color
 * @param {number} lum - A number for defining luminosity
 */

var getDarkerHex = function getDarkerHex(hex, lum) {
  if (/(^#?[0-9A-F]{6}$)|(^#?[0-9A-F]{3}$)/i.test(hex)) {
    var hexConverted = String(hex).replace(/[^0-9a-f]/i, '');

    if (hexConverted.length < 6) {
      hexConverted = hexConverted[0] + hexConverted[0] + hexConverted[1] + hexConverted[1] + hexConverted[2] + hexConverted[2];
    }

    var l = lum || 0; // convert to decimal and change luminosity

    var rgb = '#';

    for (var i = 0; i < 3; i++) {
      var c = parseInt(hexConverted.substr(i * 2, 2), 16);
      c = Math.round(Math.min(Math.max(0, c + c * l), 255)).toString(16);
      rgb += "00".concat(c).substr(c.length);
    }

    return rgb;
  }

  return 'transparent';
};

var useButtonStyle = function useButtonStyle(backgroundColor, textColor, backgroundHoverColor, textHoverColor) {
  var styles = backgroundColor || textColor ? {
    backgroundColor: formatColor(backgroundColor),
    color: formatColor(textColor),
    borderColor: backgroundColor ? getDarkerHex(backgroundColor, -0.25) : null
  } : null;

  var _useState = useState(styles),
      _useState2 = _slicedToArray(_useState, 2),
      buttonStyles = _useState2[0],
      setButtonStyles = _useState2[1];

  useEffect(function () {
    if (backgroundHoverColor || textHoverColor) {
      setButtonStyles({
        backgroundColor: formatColor(backgroundHoverColor),
        color: formatColor(textHoverColor),
        borderColor: backgroundColor ? getDarkerHex(backgroundHoverColor, -0.25) : null
      });
    } else {
      setButtonStyles(styles);
    }

    return function cleanup() {
      setButtonStyles(null);
    };
  }, [backgroundColor, textColor, backgroundHoverColor, textHoverColor]);
  return buttonStyles;
};

var useHover = function useHover() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var handleMouseOver = useCallback(function () {
    return setValue(true);
  }, []);
  var handleMouseOut = useCallback(function () {
    return setValue(false);
  }, []);
  var ref = useRef();
  var callbackRef = useCallback(function (node) {
    if (ref.current) {
      ref.current.removeEventListener('mouseover', handleMouseOver);
      ref.current.removeEventListener('mouseout', handleMouseOut);
    }

    ref.current = node;

    if (ref.current) {
      ref.current.addEventListener('mouseover', handleMouseOver);
      ref.current.addEventListener('mouseout', handleMouseOut);
    }
  }, [handleMouseOver, handleMouseOut]);
  return [callbackRef, value];
};

var Button = function Button(_ref) {
  var itemProps = _ref.itemProps;
  return React.createElement(Common, {
    render: function render(_ref2) {
      var labels = _ref2.labels;

      var _useHover = useHover(),
          _useHover2 = _slicedToArray(_useHover, 2),
          hoverRef = _useHover2[0],
          isHovered = _useHover2[1];

      var _useSelector = useSelector(function (state) {
        return state.requestData;
      }),
          widgetName = _useSelector.widgetName,
          windowId = _useSelector.windowId;

      var btnLabel = itemProps.btnLabel,
          btnClasses = itemProps.btnClasses,
          btnHref = itemProps.btnHref,
          btnTarget = itemProps.btnTarget,
          backgroundColor = itemProps.backgroundColor,
          textColor = itemProps.textColor,
          backgroundHoverColor = itemProps.backgroundHoverColor,
          textHoverColor = itemProps.textHoverColor,
          btnAttributes = itemProps.btnAttributes,
          image = itemProps.image,
          hoverImage = itemProps.hoverImage;
      var styles = useButtonStyle(backgroundColor, textColor);
      var hoverStyles = useButtonStyle(backgroundColor, textColor, backgroundHoverColor, textHoverColor);
      var btnHTML = btnLabel ? labels.getHTML(btnLabel) : null;
      var btnText = btnLabel ? labels.get(btnLabel) : null;
      var markup = !image ? btnHTML : React.createElement("img", {
        src: isHovered && hoverImage ? hoverImage : image,
        title: btnText,
        alt: btnText
      });
      return React.createElement("a", _extends({
        ref: hoverRef,
        className: btnClasses,
        href: btnHref,
        target: btnTarget,
        alt: btnText,
        style: isHovered ? hoverStyles : styles,
        onClick: function onClick() {
          return trackEvent(widgetName, windowId, {
            element: 'CTA Button/Link',
            elementCTA: btnText,
            result: 'Navigated to CTA destination'
          });
        }
      }, btnAttributes), markup);
    }
  });
};

Button.propTypes = {
  itemProps: PropTypes.shape({
    btnLabel: PropTypes.string,
    btnClasses: PropTypes.string,
    btnHref: PropTypes.string,
    btnTarget: PropTypes.string,
    backgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    backgroundHoverColor: PropTypes.string,
    textHoverColor: PropTypes.string,
    btnAttributes: PropTypes.shape({}),
    image: PropTypes.string,
    hoverImage: PropTypes.string
  })
};
Button.defaultProps = {
  itemProps: {
    btnLabel: null,
    btnClasses: null,
    btnHref: null,
    btnTarget: null,
    backgroundColor: null,
    textColor: null,
    backgroundHoverColor: null,
    textHoverColor: null,
    btnAttributes: {},
    image: null,
    hoverImage: null
  }
};

var ButtonContainer = function ButtonContainer(_ref) {
  var itemProps = _ref.itemProps,
      id = _ref.id,
      buttonLength = _ref.buttonLength;
  return React.createElement(Common, {
    render: function render(_ref2) {
      var labels = _ref2.labels;
      var index = itemProps.index,
          popoverText = itemProps.popoverText;
      var popoverHTML = popoverText ? labels.getHTML(popoverText) : null;
      var buttonContainer = React.createElement("div", {
        className: setClassNames(['price-btn', "cst-btn-".concat(index), buttonLength !== index + 1 ? 'mb-3' : null])
      }, React.createElement(Button, {
        itemProps: itemProps
      }));

      var _useSelector = useSelector(function (state) {
        return state.requestData;
      }),
          deviceType = _useSelector.deviceType;

      if (popoverHTML && deviceType !== 'MOBILE') {
        var popover = React.createElement(Popover, {
          id: "".concat(id, "-popover")
        }, popoverHTML);
        return React.createElement(OverlayTrigger, {
          key: id,
          trigger: ['hover', 'focus'],
          placement: "left",
          overlay: popover
        }, buttonContainer);
      }

      return buttonContainer;
    }
  });
};

ButtonContainer.propTypes = {
  itemProps: PropTypes.shape({
    index: PropTypes.number,
    popoverText: PropTypes.string
  }).isRequired,
  id: PropTypes.string.isRequired,
  buttonLength: PropTypes.number.isRequired
};

var ButtonList = function ButtonList(_ref) {
  var buttons = _ref.buttons;

  if (buttons && buttons.length > 0) {
    return React.createElement("div", {
      className: "vehicle-ctas"
    }, buttons.map(function (item, index) {
      var itemProps = _objectSpread2({}, item, {
        index: index
      });

      var id = "button-".concat(itemProps.index);
      return React.createElement(ButtonContainer, _extends({
        key: id,
        buttonLength: buttons.length
      }, {
        itemProps: itemProps,
        id: id
      }));
    }));
  }

  return null;
};

ButtonList.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
ButtonList.displayName = 'ButtonList';

var asyncFunc =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", Promise.resolve('done'));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function asyncFunc() {
    return _ref.apply(this, arguments);
  };
}();

export { ButtonList, asyncFunc };
//# sourceMappingURL=es.js.map



//////////////////
// WEBPACK FOOTER
// ./~/wsm-vehicle-cta-display/dist/es.js
// module id = 24
// module chunks = 0